import React from 'react';
import type { FC } from 'react';

import { Button, ButtonSize, ButtonType } from '@/common/button';
import { Modal } from '@/common/modal';
import { WarningIcon } from '@/common/warning-icon';

interface ReconcileCreativeModalProps {
    onCancel?: () => void;
    onConfirm?: () => void;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

export const ReconcileCreativeModal: FC<ReconcileCreativeModalProps> = ({ onCancel, onConfirm, isOpen, setIsOpen }) => {
    return (
        <Modal isOpen={isOpen}>
            <div className="flex flex-col absolute min-w-96 w-[42vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out">
                <div className="flex flex-row gap-2 p-4 items-center">
                    <WarningIcon />
                    <p className="text-lg text-orange-60">You May Lose Content</p>
                </div>
                <hr className="bg-gray-100 border-gray-120" />
                <div className="flex flex-col px-4 py-6 gap-3">
                    <p className="text-base text-gray-50 font-normal">
                        The template used in this creative has been updated by the designer. You may lose some or all of
                        your previously entered content.
                    </p>
                    <p className="text-lg text-white">Do you wish to continue editing this creative?</p>
                </div>
                <hr className="bg-gray-100 border-gray-120" />
                <div className="w-full flex flex-row justify-end gap-3 p-6">
                    <Button
                        title="Cancel"
                        className="px-5"
                        buttonType={ButtonType.SECONDARY}
                        buttonSize={ButtonSize.LARGE}
                        onClick={() => {
                            setIsOpen(false);
                            onCancel?.();
                        }}
                    />
                    <Button
                        title="Continue to Edit"
                        buttonType={ButtonType.PRIMARY}
                        buttonSize={ButtonSize.LARGE}
                        onClick={() => {
                            setIsOpen(false);
                            onConfirm?.();
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};
